import { useTranslation } from "react-i18next";
import CustomSelect from "../Forms/Element/CustomSelect";

const MonthSelect = (props) => {

    const { ordinal } = props; 
    const { t } = useTranslation();
    const months = [
        'january',
        'february',
        'march',
        'april',
        'may',
        'june',
        'july',
        'august',
        'september',
        'october',
        'november',
        'december',
    ];
    const options = months.map((month, index) => ({
        value: index + 1,
        label: ordinal ? (index + 1) < 10 ? "0" + (index + 1) : (index + 1) : t('month.' + month),
    }));

    // Exibe sempre o rótulo da própria lista para o mês escolhido. A tela que monta o valor
    // inicial só com o número ({ value: 9, label: 9 }) mostrava "9" em vez de "Setembro", e
    // resolver aqui também acompanha o carregamento tardio das traduções.
    const selected = props.value
        ? options.find((option) => option.value === props.value.value) || props.value
        : props.value;

    return (
        <CustomSelect
            options={options}
            {...props}
            value={selected}
        />
    );
}

export default MonthSelect;